
<template>

  <div class="card card-front front-card">
    <header class="card-header">
      <div class="status full-status spider-status" :style="{'background-color': $store.getters.getStatusOfRoom(room.did).color}">
        <div class="ob-header card-header">
          <div class="card-title">
            <h3>{{truncate(room.info.hvacName, 30, 27)}}</h3>
            <h6 style="display:flex;justify-content:center;align-items:center;">
              {{clauses.condProf}}
              <v-popover offset="15" trigger="hover" v-if="$store.state.user.tutorial">
                 <img style="height:18px;margin-left:5px;" src="@/assets/hoverInfo.png"/>
                 <template slot="popover">
                   <hover-component :options="spiderHoverOptions()"></hover-component>
                 </template>
              </v-popover>
            </h6>
          </div>
          <!-- <div class="ob-img card-settings" @click="$emit('initFlip', {from: 'spider', to: 'front'})">
            <img style="height:30px;" src="https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/back.png"/>
          </div> -->
          <div class="ob-img">
            <img src="https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/virus.png" />
          </div>
        </div>
        <div class="card-head-sep"></div>
      </div>
    </header>
    <div class="card-body side-body spider-body" style="margin-top:30%;">
        <div class="spider-plot" :id="`spider-chart${index}`"></div>
        <toggle-component :curr="4" v-on:flip="$emit('initFlip', {from: 'spider', to: $event})"></toggle-component>
        <h4>{{clauses.lastUp}}: {{normalizeUpdated()}}</h4>
    </div>
  </div>

</template>

<script>

import { mapState } from 'vuex';
import VueHighcharts from 'vue-highcharts';
import More from 'highcharts/highcharts-more';
import Highcharts from 'highcharts';
More(Highcharts);

import moment from 'moment';
import cToF from 'celsius-to-fahrenheit';
import Lang from '@/lib/langTemplates/CardTemplate';
import Thresh from '@/lib/spiderThresh';

import Toggle from './Toggle';
import Hover from '../hover/Hover';

export default {

  data(){
    return {
    }
  },

  props: ['room', 'status'],

  components: {
    'toggle-component': Toggle,
    'hover-component': Hover
  },

  computed: {
    index(){
      return this.$store.getters.getIndexOfRoom(this.room.did);
    },
    clauses(){
      let lPref = this.$store.state.lang;
      return Object.keys(Lang.clauses).reduce((a, i) => {
        a[i] = Lang.clauses[i][lPref];
        return a;
      }, {});
    },
    tutorial(){
      return this.$store.state.user.tutorial;
    }
  },

  methods: {

    truncate(name, max, end){
      return name.length < max ? name : name.substr(0, end) + '...'
    },

    plotSpider(){
      const self = this;
      const parentDays = this.parent ? this.parent.meas.days : this.room.meas.days;
      const chart = {

        chart: {
            polar: true,
            backgroundColor: 'none',
            type: 'area'
        },

        accessibility: {
        },

        title: false,

        pane: {
            width: '100%',
            height: '350px'
        },

        xAxis: {
            type: 'axis',
            useHtml: true,
            categories: [
              `${this.clauses.filter}:<br />${this[this.parent ? 'parent' : 'room'].meas && parseInt(this[this.parent ? 'parent' : 'room'].meas.days) ? this[this.parent ? 'parent' : 'room'].meas.days + self.clauses.days : 'no data'}`,
              `${this.clauses.temp}:<br />${this.room.meas && parseInt(this.room.meas.ttp)
                ? (this.$store.state.user.metric ? Math.round(this.room.meas.ttp) : Math.round(cToF(this.room.meas.ttp))) + (this.$store.state.user.metric ? '˚C' : '˚F')
                : 'no data'}`,
              `${this.clauses.hum}:<br />${this.room.meas && parseInt(this.room.meas.hhm) ? Math.round(this.room.meas.hhm) + ' %' : 'no data'}`,
              `tVOC:<br />${this.room.meas && this.room.meas.voc ? this.room.meas.voc + '<br />' : '-'}ppm`,
              `${this.clauses.co2}:<br />${this.room.meas && parseInt(this.room.meas.co2) ? Math.round(this.room.meas.co2) + 'ppm' : 'no data'}`
            ],
            tickmarkPlacement: 'off',
            lineWidth: 0,
            text: '{point.val}',
            labels: {
              formatter(){
                let val;
                const value = this.value.toString()
                if (value.includes(self.clauses.filter)) {
                  val = 'days';
                } else if (value.includes(self.clauses.temp)) {
                  val = 'ttp';
                } else if (value.includes(self.clauses.hum)) {
                  val = 'hhm';
                } else if (value.includes('tVOC')) {
                  val = 'voc';
                } else if (value.includes(self.clauses.co2)) {
                  val = 'co2';
                }
                return `<span style="color: ${spiderStatus({rdg: val, room: self[self.parent && self.parent.info && val == 'days' ? 'parent' : 'room']})}">${this.value === 'days' ? self.clauses.days : this.value}</span>`;
                // return this.value;
              },
              style: {
                color: 'white',
                fontFamily: 'Comfortaa',
                fontSize: '1.2em'
              }
            }
        },
        yAxis: {
          gridLineInterpolation: 'polygon',
          lineWidth: 0,
          min: 0,
          max: 100,
          labels: {
            style: {
              color: 'none',
              fontFamily: 'Comfortaa'
            }
          }
        },

        tooltip: false,

        legend: false,
        credits: false,
        plotOptions: {
          line: {
            dataLabels: {
              color: 'white',
              size: '1.2em'
            }
          }
        },

        series: [
          {
            enableMouseTracking: false,
            data: this.parseSeries()
          }
        ],

        responsive: {
            rules: [{
                condition: {
                    maxWidth: 500
                },
                chartOptions: {
                    legend: {
                        align: 'center',
                        verticalAlign: 'bottom',
                        layout: 'horizontal'
                    },
                    pane: {
                        size: '70%'
                    }
                }
            }]
        }

      }

      if (['days', 'ttp', 'hhm', 'voc', 'co2'].some(i => spiderStatus({rdg: i, room: this[this.parent && this.parent.info && i == 'days' ? 'parent' : 'room']}) === '#ff0000')) {
        chart.series[0].color = 'rgba(168, 34, 50, .75)';
        chart.series[0].lineColor = '#ff0000';
        chart.series[0].marker = {fillColor: '#ff0000'};
      } else if (['days', 'ttp', 'hhm', 'voc', 'co2'].some(i => spiderStatus({rdg: i, room: this[this.parent && this.parent.info && i == 'days' ? 'parent' : 'room']}) === '#fccf00')) {
        chart.series[0].color = 'rgba(199, 172, 78, .75)';
        chart.series[0].lineColor = '#fccf00';
        chart.series[0].marker = {fillColor: '#fccf00'};
      } else if (this.goodAndNoData()) {
        chart.series[0].color = 'rgba(102, 173, 95, .75)';
        chart.series[0].lineColor = '#39e244';
        chart.series[0].marker = {fillColor: '#39e244'};
      } else {
        chart.series[0].color = 'rgba(0, 153, 191, .75)';
        chart.series[0].lineColor = '#0077fe';
        chart.series[0].marker = {fillColor: '#0077fe'};
      }
      this.target = Highcharts.chart(`spider-chart${this.index}`, chart);
    },

    goodAndNoData(){
      const stati = ['days', 'ttp', 'hhm', 'voc', 'co2'].reduce((a, i) => {
        if (spiderStatus({rdg: i, room: this[this.parent && this.parent.info && i == 'days' ? 'parent' : 'room']}) == '#39e244') {
          a.good ++
        }
        if (spiderStatus({rdg: i, room: this[this.parent && this.parent.info && i == 'days' ? 'parent' : 'room']}) == 'rgb(0, 153, 191)') {
          a.noData ++;
        }
        return a;
      }, {good: 0, noData: 0});
      return stati.good > 1 || (stati.good > 1 && stati.noData > 1);
    },

    parseSeries(){
      const meas = this.room.meas;
      const self = this;
      let series = ['days', 'ttp', 'hhm', 'voc', 'co2'].map(i => {
        let pRdg = meas[i];
        if (i == 'days') {
          if (this.parent) pRdg = this.parent.meas.days;
        }
        if (i !== 'voc') {
          return new Plot({rdg: i, val: pRdg && parseInt(pRdg) ? pRdg : 0});
        } else {
          return new Plot({rdg: i, val: pRdg})
        }
      });
      series.forEach(s => s.setRelative())
      series = series.reduce((a, i) => {
        return a.concat(i.data);
      }, []);
      return series;
    },

    normalizeUpdated(){
      return this.room.meas && this.room.meas.tms
        ? moment(this.room.meas.tms * 1000).format('MMM DD @ hh:mm A')
        : '-';
    },

    spiderHoverOptions(){
      return {
        type: 'full',
        temp: 'Util',
        instance: 'ContagionRiskProfile'
      }
    }

  },

  mounted(){
    if (this.room.parent && typeof this.room.parent == 'string') this.parent = this.$store.getters.getParentRoom(this.room.parent) || false;
    this.plotSpider();
  },

  watch: {
    '$store.state.user.metric': function(newData, oldData){
      this.plotSpider();
    }
  }

}

class Plot {
  constructor(meas){
    this.rdg = meas.rdg;
    this.val = meas.val;
  }
  setRelative(){
    switch (this.rdg){
      case 'days':
        this.data = percentHigher(this.val > 0 ? this.val : 0, 180);
      break;
      case 'ttp':
        this.data = percentHigher(this.val, 35);
      break;
      case 'hhm':
        this.data = [this.val]
      break;
      case 'voc':
        this.data = percentHigher(this.val && this.val <= .734 ? this.val : 0, 1, true);
      break;
      case 'co2':
        this.data = percentHigher(this.val, 1750);
      break;
    }
  }
}

function percentHigher(v, d, dec){
  const perc = Math.round((v/d) * 100);
  // if (!dec) {
    return perc < 100 ? perc : 100;
  // }
  // return perc;
}

function spiderStatus(status){
  if (status.room.meas && status.room.meas[status.rdg]) {
    let rdg = status.room.meas[status.rdg];
    if (status.rdg == 'voc') {
      if (rdg >= 0.245 && rdg <= 0.734) {
        return '#ff0000';
      } else if (rdg >= 0.122 && rdg <= 0.244) {
        return '#f6d857';
      } else if (rdg >= 0 && rdg <= 0.121) {
        return '#39e244';
      } else {
        return 'rgb(0, 153, 191)';
      }
    } else {
      const thresh = Thresh[status.rdg];
      if ((rdg >= thresh.crit.min && rdg <= thresh.crit.max) || (thresh.crit2 && rdg >= thresh.crit2.min && rdg <= thresh.crit2.max)) {
        return '#ff0000';
      } else if ((rdg >= thresh.bad.min && rdg <= thresh.bad.max) || (thresh.bad2 && rdg >= thresh.bad2.min && rdg <= thresh.bad2.max)) {
        return '#fccf00';
      } else if (rdg >= thresh.good.min && rdg <= thresh.good.max) {
        return '#39e244';
      } else {
        return 'rgb(0, 153, 191)';
      }
    }
  } else {
    return 'rgb(0, 153, 191)';
  }
}

</script>

<style>

.spider-plot {
  width: 100%;
  margin-top: -10%;
  /* padding: 10px; */
  /* margin-top: -10%; */
}

.icon-label {
  margin: 14px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}

.icon-label h5 {
  position: absolute;
  bottom: -15px;
}

.spider-status {
  background: rgb(0, 153, 191);
}

.spider-body {
  height: 78%;
  display: flex;
  justify-content: flex-start;
}

.spider-body h3 {
  margin-bottom: 3%;
  border-bottom: 2px solid rgb(0, 153, 191);
}

.spider-body h3, h4, small {
  margin: 2px;
  font-weight: lighter;
}

.spider-body h4 {
  position: absolute;
  bottom: 0%;
  font-size: .85em;
}

.highcharts-xaxis-labels span {
  opacity: 1;
}

</style>



// WEBPACK FOOTER //
// src/components/card/Spider.vue